import { useCallback } from 'react';
import { useQuery } from 'react-query';

import Block from 'shopper/components/Block';

import { setLocalStorage } from 'lib/localStorage';
import { topbarQueryKeys } from 'lib/queryKeys';
import { get } from 'lib/request';
import { toTabCount } from 'lib/string';

import { useUser } from 'providers/UserProvider';

import TopbarBottom from './TopbarBottom';
import TopbarMain from './TopbarMain';

import LOCAL_STORAGE from 'constants/localStorage';
import TOPBAR from 'constants/topbar';

// "Key" are actually ids
const COUNTERS_INITIAL_DATA = {
  lastCouponKey: 0,
  lastForumKey: 0,
  lastCommentKey: 0,
};

const Topbar = () => {
  const { isLoggedIn } = useUser();
  // We get the last id from the main dynamic content from some
  // sections of the app like last comments, coupons and threads
  // and subtract from the last persisted id on localStorage
  // Very primitive and not very safe but works for now
  const { data: counters } = useQuery(topbarQueryKeys.counts(), {
    queryFn: () => get('/header/count'),
    enabled: isLoggedIn,
    refetchOnWindowFocus: true,
    initialStale: true,
    initialData: COUNTERS_INITIAL_DATA,
  });

  const onCouponsClick = useCallback(() => {
    setLocalStorage(LOCAL_STORAGE.LAST_COUPON_KEY, counters.lastCouponKey);
  }, [counters]);

  const onForumClick = useCallback(() => {
    setLocalStorage(LOCAL_STORAGE.LAST_FORUM_KEY, counters.lastForumKey);
  }, [counters]);

  const onLastCommentsClick = useCallback(() => {
    setLocalStorage(LOCAL_STORAGE.LAST_COMMENT_KEY, counters.lastCommentKey);
  }, [counters]);

  return (
    <Block position="relative" display={['none', null, null, 'block']}>
      <TopbarMain
        gaEventCategory={TOPBAR.GA_EVENT_CATEGORY}
        couponsCount={toTabCount(
          counters?.lastCouponKey,
          LOCAL_STORAGE.LAST_COUPON_KEY
        )}
        threadsCount={toTabCount(
          counters?.lastForumKey,
          LOCAL_STORAGE.LAST_FORUM_KEY
        )}
        onCouponsClick={onCouponsClick}
        onForumClick={onForumClick}
      />
      <TopbarBottom
        gaEventCategory={TOPBAR.GA_EVENT_CATEGORY}
        commentsCount={toTabCount(
          counters?.lastCommentKey,
          LOCAL_STORAGE.LAST_COMMENT_KEY
        )}
        onLastCommentsClick={onLastCommentsClick}
      />
    </Block>
  );
};

export default Topbar;
